import {LazyLoadImage} from "react-lazy-load-image-component";
import {useAppDispatch, useAppSelector} from "../../../stores/store.ts";
import DateHelper from "../../../helpers/dateHelper.ts";
import {ButtonSize, ButtonVariant} from "../../../types/button.ts";
import Button from "../../buttons/Button.tsx";
import {epgDetailsActions, getEpgDetailsNextEpisodeComingAsync} from "./epgDetailsSlice.ts";
import {IPlayerChannel} from "../../../interfaces/IPlayerUIState.ts";
import PlayButton, {IPlayButtonChannel} from "../../buttons/PlayButton.tsx";
import {IChannelEpgPage} from "../../../interfaces/IChannelEpgPage.tsx";
import {XMarkIcon} from "@heroicons/react/24/solid";
import {useModal} from "../../../hooks/useModal.tsx";
import {RecordButton} from "../../buttons/RecordButton.tsx";
import {ReminderButton} from "../../buttons/ReminderButton.tsx";
// import { RecordButton } from "../../buttons/RecordButton.tsx";
// import { ReminderButton } from "../../buttons/ReminderButton.tsx";

interface IProps {
    channels: IPlayerChannel[] | IChannelEpgPage[],
}

const EpgDetailsMainView = ({channels}: IProps) => {
    const {setIsBackButtonVisible, setBackButtonAction} = useModal();
    const dispatch = useAppDispatch();
    const epgDetails = useAppSelector(store => store.epgDetails);
    const handleNextEpisodesOnClick = (epgId: number) => {
        setBackButtonAction(() => {
            setIsBackButtonVisible(false);
            dispatch(epgDetailsActions.setSelectedView("MAIN_VIEW"));
            console.log("wykonuje");
        })
        dispatch(getEpgDetailsNextEpisodeComingAsync(epgId));
        setIsBackButtonVisible(true);
    }

    const getChannelToPlayButton = (ch_id: number): IPlayButtonChannel => {
        const channel = channels.find((x) => x.ch_id === ch_id);
        return {ch_id: channel?.ch_id, enabled: channel?.enabled, name: channel?.name} as IPlayButtonChannel
    }

    return (
        <div
            className={"modal-opacity-ease-in-out-animation w-full h-full px-3 flex-1 flex flex-col pb-1"}>
            <p className={"text-base text-sky-500"}>
                {DateHelper.GetHourAndMinuteFromUnixTimespanDate(
                    epgDetails?.startTimestamp
                )}{" "}
                -{" "}
                {DateHelper.GetHourAndMinuteFromUnixTimespanDate(
                    epgDetails?.endTimestamp
                )}
            </p>
            <p className={"text-base mt-2 font-normal text-neutral-200 mb-3 flex-1 overflow-y-auto"}>
                {epgDetails?.description}
            </p>
            <div className={"flex justify-start items-center space-x-reverse overflow-x-auto scrollbar-hide"}>
                {
                    epgDetails.startTimestamp <= DateHelper.GetDateTimeNowAsUnixTimespan() &&
                    epgDetails.endTimestamp > DateHelper.GetDateTimeNowAsUnixTimespan() &&
                    channels.find(
                        (x) => x.ch_id === epgDetails.channelId
                    )?.enabled &&
                    <PlayButton
                        withUnavailableModal={true}
                        loggedInElem={
                            <span
                                className={"inline-block rounded-full bg-[#008DD2] border border-[#008dd2] hover:border-[#007CC1] hover:bg-[#007CC1] transition-colors py-1.5 px-4 focus:outline-none font-light tracking-wider"}>Oglądaj
                            </span>}
                        loggedOutElem={<span
                            className={"inline-block rounded-full bg-[#008DD2] border border-[#008dd2] hover:border-[#007CC1] hover:bg-[#007CC1] transition-colors py-1 px-4 focus:outline-none font-light tracking-wider"}>Zaloguj
                            się
                        </span>}
                        channel={getChannelToPlayButton(epgDetails.channelId)}
                        className={"focus:outline-none mb-2 mr-2"}/>
                }
                <Button
                    size={ButtonSize.BASE}
                    variant={ButtonVariant.TERTIARY}
                    onClick={() => handleNextEpisodesOnClick(epgDetails.epgId)}
                    className="text-nowrap mr-2 mb-2 flex-shrink-0 py-2"
                >
                    {epgDetails.category &&
                    epgDetails.category
                        .toLowerCase()
                        .includes("odc") || epgDetails.category.toLowerCase().includes("serial") || epgDetails.category.toLowerCase().includes("odc.")
                        ? "Więcej odcinków"
                        : "Powtórki programu"}
                </Button>
                {import.meta.env.VITE_BACKEND_TYPE == "php" &&
                    <>
                        {epgDetails.endTimestamp > DateHelper.DateTimeNowUnixTimestamp() &&
                            <RecordButton epgId={epgDetails.epgId}/>
                        }
                        <ReminderButton/>
                    </>

                }
            </div>
        </div>
    );
};

export default EpgDetailsMainView;